import { put } from "redux-saga/effects";

import { apiFetch } from "common/utilities";
import { fetchFollowedTopicsFailure, fetchFollowedTopicsSuccess } from "entities/topics/actions";
import type { FetchFollowedTopicsListDefaultAction } from "entities/topics/actionTypes";
import type { Topic } from "entities/topics/types";

export function* fetchFollowedTopicsSaga(action: FetchFollowedTopicsListDefaultAction) {
  try {
    const { limit, offset } = action.meta;
    const topics: Topic[] = yield apiFetch("topic/following", {
      queryParams: { offset, limit },
    });
    yield put(fetchFollowedTopicsSuccess({ topics, limit, offset }));
  } catch {
    yield put(fetchFollowedTopicsFailure({ logoutOnAuthError: true }));
  }
}
